import { QUERY_KEY } from 'constants/globalConstants'
import DashboardService from 'apiService/dashboardService'
import { useQuery } from 'react-query'

const useClientDowntime = (order) => {
    return useQuery(QUERY_KEY.GET_CLIENT_DOWNTIME, () => DashboardService.getDowntime(order), {retry: false})
}

export default useClientDowntime